/**
 * @generated SignedSource<<ba7ed9f77d3d2c79071b4428bf99942b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditMainPrioritySelector_Todo$data = {
  readonly id: string;
  readonly priority: TodoPriority;
  readonly updatedAtDate: {
    readonly isoString: string;
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly " $fragmentType": "WorkspaceTodoEditMainPrioritySelector_Todo";
};
export type WorkspaceTodoEditMainPrioritySelector_Todo$key = {
  readonly " $data"?: WorkspaceTodoEditMainPrioritySelector_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainPrioritySelector_Todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoEditMainPrioritySelector_Todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "updatedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};

(node as any).hash = "11b2b1446cbf93948f13c752aea2367b";

export default node;
